import {SchemaState} from "../SchemaState";
import {PlayerDataAdapter, PlayerDataListener} from "../PlayerDataAdapter";
import {createHtmlElement} from "../lib/domFunctions";
import {Messages} from "../messages/Messages";
import {ContainerListItem} from "../dto/com.rico.sb2.service.queue";
import {fetchJson, fetchJsonForApiResponse} from "../lib/fetch";
import {AppConfig} from "../AppConfig";
import {Page} from "../dto/org.springframework.data.domain";
import {ContainerState} from "../dto/com.rico.sb2.entity.detail";
import {FinishedListItem} from "./FinishedListItem";
import {PlayerData_ContainerInfo} from "../dto/com.rico.sb2.service.positions";

const messages = new Messages();

const emptyMessage = messages.get('FinishedList.emptyListMessage');
const forbiddenMessage = messages.get('FinishedList.forbiddenMessage');

export class FinishedList implements PlayerDataListener {
	element: HTMLElement;

	private readonly tableElement: HTMLElement;
	private readonly tableEmpty: HTMLDivElement;

	private items: FinishedListItem[] = []
	private query = {pageSize: 50, pageNumber: 0}

	constructor(schemaState: SchemaState, playerData: PlayerDataAdapter) {
		this.element = document.getElementById('listFinished')!

		this.tableElement = this.element.querySelector('[data-bind="listFinished"]')!
		this.tableEmpty = createHtmlElement('div', {class: 'text-muted fst-italic text-center p-3'}, ``)
		this.changeNotice(emptyMessage);
		this.queryNext();

		playerData.playerDataListeners.add(this)
	}

	changeNotice(message: string) {
		this.tableEmpty.remove()

		if (this.items.length == 0) {
			this.tableEmpty.innerText = message
			this.tableElement.append(this.tableEmpty)
		}
	}

	private queryNext() {
		fetchJson(`${AppConfig.CP}/queue/finished/slice?pageSize=${this.query.pageSize}&pageNumber=${this.query.pageNumber}`)
			.then(page => this.receivePage(page))
			.catch(error => {
				this.items = []
				this.changeNotice(error == 403 ? forbiddenMessage : emptyMessage)
			});
	}

	private receivePage(page: Page<ContainerListItem>) {
		const knownItems = new Set()
		this.items.forEach(i => knownItems.add(i.data.id));

		page.content
			.filter(i => !knownItems.has(i.id))
			.reverse()
			.forEach(i => this.display(i, null))
		this.changeNotice(emptyMessage);

		this.query.pageNumber = page.number + 1
	}

	onContainerModify(m: PlayerData_ContainerInfo): void {
		if (m.state != ContainerState.FINISHED) return
		this.refreshFromServer(m.id);
	}

	onContainerRemoved(m: PlayerData_ContainerInfo) {
		if (m.state != ContainerState.FINISHED) return
		this.refreshFromServer(m.id);
	}

	private refreshFromServer(id: number) {
		fetchJsonForApiResponse(`${AppConfig.CP}/op/containerListItem?id=${id}`).then(item => {
			const knownIndex = this.items.findIndex(item => id == item.data.id)
			this.display(item, knownIndex < 0 ? null : knownIndex);

			if (knownIndex >= 0) {
				this.items[knownIndex + 1].element.remove();
				this.items.splice(knownIndex + 1, 1);
			}
		});
	}

	private display(i: ContainerListItem, insertPosition: null | number) {
		const widget = new FinishedListItem(i);

		if (insertPosition == null) {
			this.tableElement.append(widget.element)
			this.items.push(widget);
		} else {
			let insertBefore = this.items[insertPosition].element;
			this.tableElement.insertBefore(widget.element, insertBefore)
			this.items.splice(insertPosition, 0, widget);
		}
	}
}